import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { openPanel } from 'features/taskPanel/store/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openPanel
    },
    dispatch
  )
})

const acceptedRoutes = {
  '/': {
    exact: true
  },
  '/index.html': {
    exact: true
  },
  '/archive': {
    exact: false
  },
  '/calendar': {
    exact: false
  },
  '/team/archive': {
    exact: true
  }
}

class CreateTaskButton extends PureComponent {
  onClick = () => {
    this.props.actions.openPanel()
  }

  shouldShow = () => {
    const pathname = this.props.location.pathname

    for (const route in acceptedRoutes) {
      if (acceptedRoutes[route].exact && pathname === route) {
        return true
      } else if (!acceptedRoutes[route].exact && pathname.includes(route)) {
        return true
      }
    }

    return false
  }

  render() {
    if (!this.shouldShow()) {
      return null
    }

    return (
      <div className="create-task-button-container">
        <div className="create-task-button" onClick={this.onClick}>
          +
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps,
    null
  )(CreateTaskButton)
)



// WEBPACK FOOTER //
// ./src/features/layout/components/createTaskButton/index.js